export type SearchedDomain = { domain: string } & (
	| { status: "taken" | "premium" }
	| { status: "available"; price: number }
)

export type DomainPeriodOption = { years: number; price: number }

export const dnsRecordTypes = ["A", "AAAA", "ANAME", "CNAME", "MX", "SRV", "TXT"] as const
export type DnsRecordType = (typeof dnsRecordTypes)[number]
